module.exports = __webpack_public_path__ + "img/image-user-check.a355fb36.svg";